export const parseParamLines = (text) =>
  String(text || '')
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const match = line.match(/^([^\t:=]+)[\t:=]([\s\S]*)$/);
      if (!match) return { key: line, value: '' };
      return { key: match[1].trim(), value: match[2].trim() };
    })
    .filter((row) => row.key);

export const formatParamLines = (rows) =>
  (rows || []).map((row) => `${row.key}: ${row.value ?? ''}`).join('\n');

export const moveItem = (rows, from, to) => {
  const list = [...(rows || [])];
  if (to < 0 || to >= list.length) return list;
  const [moved] = list.splice(from, 1);
  list.splice(to, 0, moved);
  return list;
};

export const copyToClipboard = (text) => {
  if (!navigator?.clipboard) return Promise.resolve(false);
  return navigator.clipboard.writeText(text).then(
    () => true,
    () => false
  );
};
